import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { SuggestionsComponent } from './suggestions.component';
import { DialogComponent } from './dialog/dialog.component';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { DetailDialogComponent } from './detail-dialog/detail-dialog.component';
import { detachEmbeddedView } from '@angular/core/src/view/view_attach';

const routes: Routes = [
    {
        path     : 'suggestions',
        component: SuggestionsComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        SuggestionsComponent,
        DialogComponent,
        DetailDialogComponent
    ],
    entryComponents: [DialogComponent, DetailDialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class SuggestionsModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/suggestions/suggestions.module.ts